<template>
  <div class="book-dopractice flex-col">
    <a-affix>
      <div class="section_nav flex-row" v-if="false">
        <img  class="thumbnail_nav" @click="goHistory" referrerpolicy="no-referrer"
             src="../../assets/image/a_left.png"/>
        <span class="text_nav">习题列表</span>
      </div>
      <a-breadcrumb class="section_nav flex-row" v-if="!isPad">
        <a-breadcrumb-item style="font-size: 18px">
          <router-link :to="'/homePage'">首页</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item style="font-size: 18px">
          <router-link :to="'/accompanyStudy/studentsExercises'">学生习题</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item style="font-size: 18px">
          习题列表
        </a-breadcrumb-item>
      </a-breadcrumb>
    </a-affix>

    <div class="book-textreadguide-content">
      <div v-for="exercise in exercises" :key="exercise.id" class="exer-i">
        <div v-if="exercise.quType === 0">
          <h2>{{ exercise.quNum }}、{{ exercise.title }}</h2>
          <practiceInfo :content="exercise.quInfo"></practiceInfo>
          <!-- 第二层 -->
          <div v-if="exercise.subQuestions.length > 0" class="exer-ii">
            <div v-for="subQuestion in exercise.subQuestions" :key="subQuestion.id">
              <div v-if="subQuestion.quType === 0">
                <h3>{{ subQuestion.quNum }}. {{ subQuestion.title }}</h3>
                <practiceInfo v-if="subQuestion.quInfo" :content="subQuestion.quInfo"></practiceInfo>
                <!-- 暂到第三层 -->
                <div v-if="subQuestion.subQuestions.length > 0">
                  <div v-for="question in subQuestion.subQuestions" :key="question.id">
                    <practice :showAnalysis="showAnalysis" :level="3"
                              :showNumber="subQuestion.subQuestions.length>1" :exercise="question">
                    </practice>
                  </div>
                </div>
              </div>
              <practice v-else :showAnalysis="showAnalysis" :level="2"
                        :showNumber="exercise.subQuestions.length>1" :exercise="subQuestion">
              </practice>
            </div>
          </div>
        </div>
        <practice v-else :showAnalysis="showAnalysis" :level="1" :exercise="exercise">
        </practice>
      </div>
    </div>
    <a-spin size="large" class="loading" v-show="loading"/>
  </div>
</template>

<script>
import { defineComponent, getCurrentInstance, ref, onMounted } from 'vue'
import Practice from '@/views/books/components/Practice.vue'
import PracticeInfo from '@/views/books/components/PracticeInfo.vue'
import { decryptDes } from 'utils/crypto.js'

export default defineComponent({
  components: {
    Practice,
    PracticeInfo
  },

  setup () {
    const { proxy } = getCurrentInstance()
    const id = ref('')
    const styleId = ref('')
    const userId = ref('')
    const access_token = ref('')
    const exercises = ref([])
    const loading = ref(false)
    const isPad = ref(false)
    const showAnalysis = ref(true)

    onMounted(() => {
      console.log('onMounted')
      console.log('onMounted', proxy.$route.params)
      init()

      if (proxy.id == null || proxy.id == '') {
        proxy.$router.push({ name: 'StudentsExercises' })
      }

      getExerciseDetail()
    })

    const init = () => {
      if (proxy.$route.path.indexOf('/accompanyStudy') === 0) {
        // 网页端
        proxy.isPad = false
        proxy.userId = proxy.$getUserInfo().id
        proxy.token = localStorage.getItem('access_token')

        proxy.id = proxy.$route.params.id
        proxy.styleId = proxy.$route.params.styleId
        proxy.userId = proxy.$route.params.userId
        proxy.token = proxy.$route.params.access_token
      } else {
        // 手机端
        proxy.isPad = true
        // const parameter = decryptDes(proxy.$route.params.parameter)
        // const params = parameter.split('&')
        // proxy.token = params[0]
        // proxy.userId = params[1]

        const obj = JSON.parse(localStorage.getItem('StudentsExercisesPhone'))
        proxy.userId = obj.userId
        proxy.token = obj.token
        proxy.styleId = obj.styleId
        proxy.id = obj.id
      }
    }

    const getExerciseDetail = () => {
      // 班级列表
      proxy
        .$fetch({
          url: proxy.$httpConfig.getByIdExamUserRecord,
          body: {
            id: proxy.id,
            styleId: proxy.styleId,
            userId: proxy.userId,
            access_token: proxy.token
          }
        })
        .done((res) => {
          console.log(res)
          if (res && res.success && res.resultCode == 0) {
            exercises.value = res.resultData
            // classData.value = res.resultData;
          }
        })
    }

    const goHistory = () => {
      proxy.$router.push({ name: 'StudentsExercises' })
    }
    return { showAnalysis, isPad, exercises, loading, goHistory }
  }
})
</script>
<style lang="less" scoped>
.book-dopractice {
  overflow-x: hidden;
  background-color: #f1f0f0;
  display: flex;
  justify-content: center;
  align-items: center;

  .loading {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(50%, 50%);
  }

  .section_nav{
    padding-top: 20px;
    padding-left: 40px;
  }
}

.book-textreadguide-content {
  border-radius: @border-radius-base;
  background-color: @white;
  width: 80vw;
  margin: 1vw 0;
  padding-top: 40px;
  padding-left: 50px;
  padding-bottom: 55px;
  padding-right: 50px;
  position: relative;

  .back-Btn {
    display: inline-block;
    justify-content: left;
    align-items: center;
    cursor: pointer;
    font-size: 20px;
    color: #999999;
    font-family: 'PingFangSC-Semibold';
    height: 30px;

    .back-Icon {
      height: 19px;
      position: relative;
      right: 10px;
    }
  }

  .back-Btn:hover {
    color: @primary-color;
  }

  .submits {
    position: absolute;
    width: 300px;
    top: 50px;
    right: 50px;
    text-align: right;

    .sub_jilu {
      background-color: #5a99ef;
      color: @white;
      margin-right: 5px;
    }
  }
}

.times {
  width: 100%;
  height: 40px;
  line-height: 43px;
  background-color: #ffffff;
  border-radius: 8px;
  border: solid 1px #dbd1cd;
  margin-bottom: 10px;
  padding: 0 20px;
  box-sizing: border-box;
  cursor: pointer;

  .colors {
    color: salmon;
    font-size: 20px;
  }

  .time_sj {
    float: left;
  }

  .time_data {
    float: left;
    margin-left: 20px;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 40px;
    letter-spacing: 0px;
    color: #353b50;
  }

  .foot {
    float: right;
    color: salmon;
  }
}

.btn {
  width: 280px;
  height: 50px;
  border-radius: 30px;
  font-size: 24px;
  color: @white;
}

.green-btn {
  background-color: #06bc8c;
}

.orange-btn {
  background-color: #ff9a4a;
}

.record {
  border-radius: @border-radius-base;
  background-color: @white;
  margin: 20px;
  padding: 40px 30px;
}

.record-title {
  font-size: 20px;
  font-weight: bold;
  margin-left: 1em;
}

.exer-i {
  margin: 10px;
}

.exer-ii {
  margin: 10px;
}
</style>
